import type { ComponentType } from 'react'

import { Metrics } from '@pages/IntroducingBroker/Dashboard/Metrics/Metrics'
import { RebatesManagement } from '@pages/IntroducingBroker/Dashboard/RebatesManagement/RebatesManagement'
import { CJMWidget } from '@pages/IntroducingBroker/DashboardPoC/components/widgets/CJMWidget'
import { IBQuickPerformanceWidget } from '@pages/IntroducingBroker/DashboardPoC/components/widgets/IBQuickPerformanceWidget'
import { IBWalletWidget } from '@pages/IntroducingBroker/DashboardPoC/components/widgets/IBWalletWidget'
import { LoyaltyProgramWidget } from '@pages/IntroducingBroker/DashboardPoC/components/widgets/LoyaltyProgramWidget'
import { PayoutSchemeWidget } from '@pages/IntroducingBroker/DashboardPoC/components/widgets/PayoutSchemeWidget'
import { ReferralLinkWidget } from '@pages/IntroducingBroker/DashboardPoC/components/widgets/ReferralLinkWidget'
import { TransactionHistoryWidget } from '@pages/IntroducingBroker/DashboardPoC/components/widgets/TransactionHistoryWidget'

import { WidgetType } from './types'

export interface WidgetVisibilityContext {
  loyaltyProgramEnabled: boolean
  isPayoutSchemeVisible: boolean
  isPartner: boolean
  ibCode?: string
  mtCode?: string
  isRebatesVisible: boolean
  isVisibilityReady: boolean
}

interface WidgetDefinition {
  component: ComponentType
  isVisible: (context: WidgetVisibilityContext) => boolean
  allowOverflow?: boolean
}

export const widgetRegistry: Record<WidgetType, WidgetDefinition> = {
  [WidgetType.IB_METRICS]: {
    component: Metrics,
    isVisible: () => true,
    allowOverflow: true,
  },
  [WidgetType.IB_WALLETS]: {
    component: IBWalletWidget,
    isVisible: () => true,
  },
  [WidgetType.IB_TRANSACTION_HISTORY]: {
    component: TransactionHistoryWidget,
    isVisible: () => true,
  },
  [WidgetType.QUICK_PERFORMANCE]: {
    component: IBQuickPerformanceWidget,
    isVisible: () => true,
  },
  [WidgetType.IB_CJM]: {
    component: CJMWidget,
    isVisible: () => true,
  },
  [WidgetType.IB_REBATES_MANAGEMENT]: {
    component: RebatesManagement,
    isVisible: ({ isRebatesVisible }) => isRebatesVisible,
  },
  [WidgetType.PAYOUT_SCHEME]: {
    component: PayoutSchemeWidget,
    isVisible: ({ isPayoutSchemeVisible }) => isPayoutSchemeVisible,
  },
  [WidgetType.LOYALTY_PROGRAM]: {
    component: LoyaltyProgramWidget,
    isVisible: ({ loyaltyProgramEnabled }) => loyaltyProgramEnabled,
  },
  [WidgetType.REFERRAL_LINK]: {
    component: ReferralLinkWidget,
    isVisible: ({ isPartner, ibCode, mtCode }) => !isPartner && Boolean(ibCode || mtCode),
  },
}
